export const RentalStatusEnum = {
    UPCOMING: 'upcoming',
    ACTIVE: 'active',
    EXPIRED: 'expired',
    SUSPENDED: 'suspended',
    RENEWAL_PENDING: 'renewal-pending',
    CANCELED: 'canceled'
};

export const CANCEL_ALLOWED_STATUSES = [
    RentalStatusEnum.UPCOMING,
    RentalStatusEnum.ACTIVE
];

export const UPDATE_RENTAL_ALLOWED_STATUSES = [
    RentalStatusEnum.UPCOMING,
    RentalStatusEnum.ACTIVE
];

export const UPDATE_RENTAL_BLOCKED_STATUSES = [
    RentalStatusEnum.EXPIRED,
    RentalStatusEnum.CANCELED
];
